import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/DeliveryOrderReport/WarehouseReportDeliveryOrderAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseReportDeliveryOrderActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/DeliveryOrderReport/WarehouseReportDeliveryOrder")
	}

	render() {
		return (
			<Activity 
				name="WarehouseReportDeliveryOrder"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseReportDeliveryOrder"
				action="WarehouseReportDeliveryOrder"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseReportDeliveryOrderActivity)
